import { render } from "./UserInfoSettings.vue?vue&type=template&id=7adc4c1a&scoped=true"
import script from "./UserInfoSettings.vue?vue&type=script&lang=js"
export * from "./UserInfoSettings.vue?vue&type=script&lang=js"

import "./UserInfoSettings.vue?vue&type=style&index=0&id=7adc4c1a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7adc4c1a"],['__file',"src/components/list-items/UserInfoSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7adc4c1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7adc4c1a', __exports__)) {
    api.reload('7adc4c1a', __exports__)
  }
  
  module.hot.accept("./UserInfoSettings.vue?vue&type=template&id=7adc4c1a&scoped=true", () => {
    api.rerender('7adc4c1a', render)
  })

}


export default __exports__